export default defineNuxtPlugin(async () => {
  try {
    // Get GTM container ID from site options using the composable
    const containerTagId = await useAcfOptions('container_tag_id');

    if (containerTagId && typeof containerTagId === 'string') {
      console.log('Initializing GTM with container ID:', containerTagId);

      // Initialize dataLayer
      window.dataLayer = window.dataLayer || [];

      // Create GTM script
      const gtmScript = document.createElement('script');
      gtmScript.async = true;
      gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${containerTagId}`;
      document.head.appendChild(gtmScript);

      // Create noscript fallback
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerTagId}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);

      // Insert noscript after body opening tag
      if (document.body.firstChild) {
        document.body.insertBefore(noscript, document.body.firstChild);
      } else {
        document.body.appendChild(noscript);
      }

      // Initialize GTM dataLayer with pageview
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
    } else {
      console.warn('GTM container ID not found');
    }
  } catch (error) {
    console.warn('Failed to initialize GTM:', error);
  }
});